/**
 * Newsletter Email Validation
 * Validates email format on all newsletter forms before submission.
 * Expected format: name@domain.tld (e.g., name@email.com)
 */
(function () {
  const EMAIL_REGEX = /^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/;
  const ERROR_CLASS = 'newsletter-email-error';
  const ERROR_MSG = 'Please enter a valid email address (e.g., name@email.com)';

  function validateEmail(email) {
    return EMAIL_REGEX.test(email.trim());
  }

  function removeError(input) {
    const field = input.closest('.field') || input.closest('.form-field') || input.parentElement;
    const existing = field.parentElement.querySelector('.' + ERROR_CLASS);
    if (existing) existing.remove();
    input.classList.remove('input--error');
    input.removeAttribute('aria-invalid');
  }

  function showError(input, message) {
    removeError(input);
    const field = input.closest('.field') || input.closest('.form-field') || input.parentElement;
    const errorDiv = document.createElement('div');
    errorDiv.className = ERROR_CLASS + ' newsletter-form__message newsletter-form__message--error form__message';
    errorDiv.setAttribute('role', 'alert');
    errorDiv.innerHTML = '<svg aria-hidden="true" focusable="false" width="13" height="13" viewBox="0 0 13 13"><circle cx="6.5" cy="6.18" r="5.82" fill="none" stroke="currentColor" stroke-width="1"/><path d="M5.87 3.52h1.26l-.14 4.2H6.01l-.14-4.2ZM6.5 8.75c.22 0 .4.07.55.22.14.14.22.33.22.55s-.07.4-.22.55c-.15.14-.33.22-.55.22s-.4-.07-.55-.22a.77.77 0 0 1-.22-.55c0-.22.07-.4.22-.55.14-.15.33-.22.55-.22Z" fill="currentColor"/></svg> ' + message;
    field.parentElement.insertBefore(errorDiv, field.nextSibling);
    input.classList.add('input--error');
    input.setAttribute('aria-invalid', 'true');
  }

  function handleFormSubmit(e) {
    const form = e.target;
    const emailInput = form.querySelector('input[type="email"][name="contact[email]"]');
    if (!emailInput) return;

    const email = emailInput.value.trim();

    if (!email) {
      e.preventDefault();
      showError(emailInput, 'Email address is required.');
      emailInput.focus();
      return;
    }

    if (!validateEmail(email)) {
      e.preventDefault();
      showError(emailInput, ERROR_MSG);
      emailInput.focus();
      return;
    }

    removeError(emailInput);
  }

  function handleInputChange(e) {
    const input = e.target;
    if (input.value.trim() && validateEmail(input.value.trim())) {
      removeError(input);
    }
  }

  function initValidation() {
    const forms = document.querySelectorAll('form.newsletter-form');
    forms.forEach(function (form) {
      form.addEventListener('submit', handleFormSubmit);
      const emailInput = form.querySelector('input[type="email"][name="contact[email]"]');
      if (emailInput) {
        emailInput.addEventListener('input', handleInputChange);
        emailInput.addEventListener('blur', function () {
          const val = emailInput.value.trim();
          if (val && !validateEmail(val)) {
            showError(emailInput, ERROR_MSG);
          }
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initValidation);
  } else {
    initValidation();
  }

  // Re-init if newsletter popup opens (for dynamically rendered forms)
  const observer = new MutationObserver(function () {
    const forms = document.querySelectorAll('form.newsletter-form:not([data-validated])');
    forms.forEach(function (form) {
      form.setAttribute('data-validated', 'true');
      form.addEventListener('submit', handleFormSubmit);
      const emailInput = form.querySelector('input[type="email"][name="contact[email]"]');
      if (emailInput) {
        emailInput.addEventListener('input', handleInputChange);
        emailInput.addEventListener('blur', function () {
          const val = emailInput.value.trim();
          if (val && !validateEmail(val)) {
            showError(emailInput, ERROR_MSG);
          }
        });
      }
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
